import {
  PHONE_CONFIG,
  MIN_INTERNATIONAL_PHONE_LENGTH,
  MAX_INTERNATIONAL_PHONE_LENGTH,
} from "constants/phoneConfig";

export const INVALID_PHONE_ERROR = "Invalid phone number for the selected country";

export const sanitizePhone = (phone) =>
  String(phone || "").replace(/[\s\-()]/g, "");

export const validateInternationalPhone = (phone, isdCode) => {
  const sanitized = sanitizePhone(phone);

  if (!sanitized) {
    return false;
  }

  const config = PHONE_CONFIG[isdCode];

  if (config) {
    const regex = new RegExp(`^${config.pattern}$`);
    return (
      regex.test(sanitized) &&
      sanitized.length >= config.minLength &&
      sanitized.length <= config.maxLength
    );
  }

  return (
    /^\d+$/.test(sanitized) &&
    sanitized.length >= MIN_INTERNATIONAL_PHONE_LENGTH &&
    sanitized.length <= MAX_INTERNATIONAL_PHONE_LENGTH
  );
};

export const getPhoneValidationError = (phone, isdCode) => {
  if (!sanitizePhone(phone)) {
    return null;
  }

  return validateInternationalPhone(phone, isdCode) ? null : INVALID_PHONE_ERROR;
};

export const formatPhoneWithOptionalIsd = (phoneNumber, isdCode) => {
  const phone = String(phoneNumber ?? "").trim();
  if (!phone) {
    return "";
  }

  const isd = String(isdCode ?? "").trim();
  return isd ? `${isd} ${phone}` : phone;
};
